import React from "react";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";

const AnswersViewSkeleton = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <div className={`${styles.skeleton} ${styles.skeletonTitle}`}></div>
          <div
            className={`${styles.skeleton} ${styles.skeletonSubtitle}`}
          ></div>
        </div>
      </div>

      <div className={styles.answersGrid}>
        {[1, 2, 3].map((i) => (
          <div key={i} className={styles.answerCard}>
            <div className={styles.answerCardHeader}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "70%", height: "24px" }}
              ></div>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "30%" }}
              ></div>
            </div>
            <div
              className={`${styles.skeleton} ${styles.skeletonText}`}
              style={{ width: "100%", height: "80px", marginTop: "10px" }}
            ></div>
            <div className={styles.answerCardFooter}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "40%" }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnswersViewSkeleton;
